/**
 * 핑크페이퍼(pinkpaper.kr) 전용 SEO 컴포넌트
 * React 19 built-in metadata support 활용 (기존 SEO.js와 동일 패턴)
 */
function PaperSEO({ title, description, path = '', image, type = 'website', jsonLd }) {
  const siteName = '핑크페이퍼';
  const baseUrl = 'https://pinkpaper.kr';
  const defaultDescription = '공연, 축제, 음원유통, 굿즈 제작 — 서로의 마음을 핑크로 연결하는 곳';
  const defaultImage = 'https://pinkpaper.kr/images/paper/logo_pinkpaper.png';

  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} — 공연·축제 기획사`;
  const desc = description || defaultDescription;
  const url = `${baseUrl}${path}`;
  const img = image || defaultImage;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="ko_KR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {/* JSON-LD Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </>
  );
}

export default PaperSEO;
